import initReactFastclick from 'react-fastclick';
export default initReactFastclick;



// WEBPACK FOOTER //
// ./src/initialize/fastclick/index.js